export const ENV = process.env.REACT_APP_ENV;
export const HOST = process.env.REACT_APP_HOST;
export const PORT = process.env.REACT_APP_PORT;

/** New B2B cabinet URL (e.g. https://220-km.com:3080). When set, OAuth callback redirects here after Google login instead of /b2b. */
export const NEW_B2B_CABINET_URL = process.env.REACT_APP_NEW_B2B_CABINET_URL || '';

/** Telegram support bot username (no @). Default: km220_bot. For stage support when running with prod BE use km220stage_bot. */
export const TELEGRAM_BOT = process.env.REACT_APP_TELEGRAM_BOT || 'km220_bot';

/** Start-page skip-payment button: local SPA on localhost only. */
export function isLocalSkipPaymentEnabled() {
  if (ENV !== 'local') return false;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}
